import {IGameFilterDefinition} from '../interfaces/game-filter-definition.interface';
import {GameInfo} from '../../games/game-info';
import {IArenaGameFiltersCategory} from "../arena-filters/arena-game-filters-category.interface";
import {computed} from "mobx";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";

/**
 * This class is used to apply a filter that does something like this:
 * Show all games that doesn't fall in any of the other available games filters categories for the current arena
 */

export class OtherFilter implements IGameFilterDefinition {
  constructor(private readonly allOthersCategories: IArenaGameFiltersCategory[]) {
  }

  get id(): string {
    return 'other';
  }

  @computed
  get currentArenaCategories(): IArenaGameFiltersCategory[] {
    return this.allOthersCategories.filter(c => c.isApplicableForCurrentArena);
  }

  applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
    const categoriesInCurrentArena = this.currentArenaCategories;
    for(let category of categoriesInCurrentArena) {
      if(category.isGameIncludedInThisCategory(gameInfo)) {
        return ApplyGameFilterResult.ExcludeGame;
      }
    }

    return ApplyGameFilterResult.IncludeGame;
  }

}
